import {
    takeEvery, call, put, fork
} from 'redux-saga/effects';
import * as api from '../api/test';
import * as actions from '../actions/testActions';

function* getTestCriterias() {
    let result = '';
    try {
        result = yield call(api.getTestCriterias);
        yield put(actions.getTasksSuccess(result.data));
    }
    catch (error) {
        yield put(actions.Types.getTasksSuccess(error));
    }
}




function* watchGetTaskRequest() {
    yield takeEvery(actions.Types.GET_TEST_CRITERIAS, getTestCriterias);
}

const testSagas = [fork(watchGetTaskRequest)];

export default testSagas;
